import { Control, useFieldArray, UseFormRegister } from 'react-hook-form';

import config from '../../../config';
import { type InquiryForm } from '../../../models/Inquiry/Inquiry';

interface Props {
  fieldIndex: number
  register: UseFormRegister<InquiryForm>
  control: Control<InquiryForm, any>
  disabled: boolean
}

export default function FormContentChildren({
  fieldIndex, control, register, disabled,
}: Props): JSX.Element {
  const { fields } = useFieldArray({
    control,
    name: `definition.${fieldIndex}.children`,
  });

  return (
    <>
      <div className="d-flex flex-column option-item">
        {
          fields?.map((child, childIndex) => (
            <div className="d-flex flex-wrap align-items-center gap-3" key={`${fieldIndex}_${child.id}_${child.item_id}`}>
              <div style={{ minWidth: '1rem' }}>
                {child.label}
                <span>：</span>
              </div>
              <div>
                <div className="form-check form-switch">
                  <input
                    {...register(`definition.${fieldIndex}.children.${childIndex}.required`)}
                    id={`required_child_${child.id}`}
                    type="checkbox"
                    className="form-check-input"
                    disabled={disabled}
                  />
                  <label className="form-check-label" htmlFor={`required_child_${child.id}`}>必須項目</label>
                </div>
              </div>
            </div>
          ))
        }
      </div>

      <div className="d-flex flex-column option-info">
        {
          fields.map((child) => (
            <div className="d-flex flex-wrap align-items-center gap-2" key={`${fieldIndex}_${child.id}_${child.item_id}`}>
              <div className="text-sm" style={{ minWidth: '1rem' }}>
                <span>【</span>
                {child.label}
                <span>】</span>
              </div>
              <div className="text-sm">
                項目タイプ：
                <span>{Object.values(config.items.types).find((i) => i.value === child?.type)?.label}</span>
              </div>
              <div className="text-sm">
                項目プレースホルダー：
                <span>{child?.placeholder || 'なし'}</span>
              </div>
              {
                [
                  config.items.types.text.value,
                  config.items.types.textarea.value,
                  config.items.types.date.value,
                  config.items.types.checkbox.value,
                  config.items.types.select.value,
                  config.items.types.number.value,
                  config.items.types.email.value,
                ].includes(child.type) && (
                  <>
                    <div className="text-sm">
                      接頭辞：
                      <span>{child?.prefix || 'なし'}</span>
                    </div>
                    <div className="text-sm">
                      接尾辞：
                      <span>{child?.suffix || 'なし'}</span>
                    </div>
                  </>
                )
              }
              {
                [
                  config.items.types.text.value,
                  config.items.types.textarea.value,
                ].includes(child.type) && (
                  <div className="text-sm">
                    文字数上限：
                    <span>{child?.max_length || 'なし'}</span>
                  </div>
                )
              }
            </div>
          ))
        }
      </div>
    </>
  );
}
